import React from 'react';
import { TableCell, Tooltip } from '@material-ui/core';
import {
  getMetricDisplayValue,
  getMetricCellStyle,
  getHeatmapCellStyle,
  getHeatmapPercentile,
  getStatsTooltipText,
} from './oodMetricConfig';

export default function PmgCompanySummaryCell({
  stats,
  metricKey,
  columnMax,
  heatmapMode,
  heatmapValues,
  onDrilldown,
  onDetail,
}) {
  const display = getMetricDisplayValue(stats, metricKey);
  const hasData = stats && stats.total_stores;
  const percentile = heatmapMode && hasData
    ? getHeatmapPercentile(stats, metricKey, heatmapValues)
    : 0;
  const style = heatmapMode && hasData
    ? getHeatmapCellStyle(stats, metricKey, percentile)
    : getMetricCellStyle(stats, metricKey, columnMax);

  const tooltip = hasData
    ? `${getStatsTooltipText(stats)}\n\nClick: open store list · Shift+click: drill-down page`
    : 'No stores for this product at this banner';

  const handleClick = (e) => {
    if (!hasData) return;
    if (e.shiftKey && onDrilldown) {
      onDrilldown(stats);
    } else if (onDetail) {
      onDetail(stats);
    }
  };

  return (
    <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{tooltip}</span>} arrow>
      <TableCell
        align="center"
        onClick={handleClick}
        style={{
          fontSize: 13,
          fontWeight: 500,
          minWidth: 72,
          backgroundColor: style.backgroundColor,
          color: style.color,
          borderLeft: style.borderLeft,
          cursor: hasData ? 'pointer' : 'default',
        }}
      >
        {display}
      </TableCell>
    </Tooltip>
  );
}
